module.exports = {
    extends: [
        '/',
        'base',
        'form',
        'form',
    ],
    config: {
        isFieldCodeSelector: true,
        preventFieldCodeSelectorFields: true,
        resourceConnected: false,
    },
    formMapping: {
        cols: [[{
            type: 'fieldGroup',
            source: 'resourceFields'
        }]]
    },
    model: {},

    methods: {
        /**
         * this function will be called after the form values has been changed.
         *
         * @param isRelationChange 		boolean - was the change related to a relation or not
         * @param changeDone 			boolean - has a change been done
         * @param fieldData 			object - fieldData used to define what to do
         */
        onChange: function(isRelationChange, changeDone, fieldData){
            if(this.config.isReady){
                fieldData = fieldData || {}
                if(fieldData.fieldCode){
                    // this.replaceResourceAttributes(this.resourceData, this.resourceData, this.model.dirtyFields)
                    const fieldProperties = this.getFieldProperties(fieldData.fieldCode) || {}
                    fieldData.parentJSONFieldCode = fieldProperties.parentJSONFieldCode
                    fieldData.fieldCode = fieldProperties.originalFieldCode || fieldData.fieldCode
                    this.triggerClosest('onColumnSelectionChanged', { fieldData }, 'base_tableSimple_table')
                }
            }
        },

        // refresh preventFieldCodeSelection param within all fields before it will be refreshed.
        // the parent-table of this component does not actively perform any actions to support changes within this columnSelector's fields.
        // therefor, the field's copies stored within this component have to be maintained here.
        onBeforeRefresh: function(options){
            this.closest('base_tableSimple_table', table => {
                for(const f in table.model.fields){
                    const tableField = table.model.fields[f]
                    const field = this.model.fields[f]
                    field.preventFieldCodeSelection = tableField.preventFieldCodeSelection
                }
            })
        }
    }
}